import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import $ from "jquery";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import aboutUsPageNewImage from "../assets/img/aboutUsPageNewImage.webp";
import bg_shape_2 from "../assets/img/shape/bg_shape_2.webp";
import feature_bg_1 from "../assets/img/feature_bg_1.webp";
import greyBanner from "../assets/img/greyBanner.webp";
import counter_1_1 from "../assets/img/icon/counter_1_1.webp";
import counter_1_2 from "../assets/img/icon/counter_1_2.webp";
import counter_1_3 from "../assets/img/icon/counter_1_3.webp";
import counter_1_4 from "../assets/img/icon/counter_1_4.webp";
import croissant_img1 from "../assets/img/croissant_img1.webp";
import breadOurProduct from "../assets/img/breadOurProduct.webp";
import cakeOurProduct from "../assets/img/cakeOurProduct.webp";
import cookiesOurProduct from "../assets/img/cookiesOurProduct.webp";
import profile_img1 from "../assets/img/profile_img1.webp";
import profile_img2 from "../assets/img/profile_img2.webp";
import profile_img3 from "../assets/img/profile_img3.webp";
import quote_left from "../assets/img/icon/quote_left.svg";
import bg_shape_3 from "../assets/img/shape/bg_shape_3.webp";
import ourLocationIcon from "../assets/img/ourLocationIcon.webp";
import bread_img1 from "../assets/img/bread_img1.webp";
import Fancybox from "../components/Fancybox";
import { Modal } from "react-bootstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import khariTwo from "../assets/img/homePageMenuItemsImages/khariTwo.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import cakeImageFiveZeppoli from "../assets/img/menuItemImages/cakeImageFiveZeppoli.webp";
import cakeImageSixZeppoli from "../assets/img/menuItemImages/cakeImageSixZeppoli.webp";
import cakeImageThreeZeppoli from "../assets/img/menuItemImages/cakeImageThreeZeppoli.webp";
import cakeImageTwoZeppoli from "../assets/img/menuItemImages/cakeImageTwoZeppoli.webp";
import dessertImageOneZeppoli from "../assets/img/menuItemImages/dessertImageOneZeppoli.webp";
import donutDelightsZeppoli from "../assets/img/menuItemImages/donutDelightsZeppoli.png";
import dessertImageTwoZeppoli from "../assets/img/menuItemImages/dessertImageTwoZeppoli.webp";
import farsanFiveZeppoli from "../assets/img/menuItemImages/farsanFiveZeppoli.webp";
import farsanFourZeppoli from "../assets/img/menuItemImages/farsanFourZeppoli.webp";
import farsanOneZeppoli from "../assets/img/menuItemImages/farsanOneZeppoli.webp";
import farsanTwoZeppoli from "../assets/img/menuItemImages/farsanTwoZeppoli.webp";
import PastryImageThree from "../assets/img/menuItemImages/PastryImageThree.webp";
import breadOneZeppoli from "../assets/img/menuItemImages/breadOneZeppoli.webp";
import breadThreeZeppoli from "../assets/img/menuItemImages/breadThreeZeppoli.webp";
import breadFourZeppoli from "../assets/img/menuItemImages/breadFourZeppoli.webp";
import breadFiveZeppoli from "../assets/img/menuItemImages/breadFiveZeppoli.webp";
import zeppoliReelVideoOne from "../assets/img/reels/zeppoliReelVideoOne.mp4";
import zeppoliReelVideoTwo from "../assets/img/reels/zeppoliReelVideoTwo.mp4";
import zeppoliReelVideoThree from "../assets/img/reels/zeppoliReelVideoThree.mp4";
import zeppoliReelVideoFour from "../assets/img/reels/zeppoliReelVideoFour.mp4";
import zeppoliReelVideoFive from "../assets/img/reels/zeppoliReelVideoFive.mp4";
import zeppoliReelVideoSix from "../assets/img/reels/zeppoliReelVideoSix.mp4";
import zeppoliReelVideoSeven from "../assets/img/reels/zeppoliReelVideoSeven.mp4";
import zeppoliReelVideoEight from "../assets/img/reels/zeppoliReelVideoEight.mp4";
import khariThree from "../assets/img/menuItemImages/khariThree.webp";
import khariFour from "../assets/img/menuItemImages/khariFour.webp";
import khariNine from "../assets/img/menuItemImages/khariNine.webp";
import NumberCounter from "../components/NumberCounter";
import JunagadhLocationImage from "../assets/img/JunagadhLocationImage.webp";
import rajkotLocationImage from "../assets/img/rajkotLocationImage.webp";
import porbandarLocationImage from "../assets/img/porbandarLocationImage.webp";
import GondalLocationImage from "../assets/img/GondalLocationImage.webp";
import JetpurLocationImage from "../assets/img/JetpurLocationImage.webp";
import KeshodLocationImage from "../assets/img/KeshodLocationImage.webp";
import DhorajiLocationImage from "../assets/img/DhorajiLocationImage.webp";
import UpletaLocationImage from "../assets/img/UpletaLocationImage.webp";
import VeravalLocationImage from "../assets/img/VeravalLocationImage.webp";
import MendardaLocationImage from "../assets/img/MendardaLocationImage.webp";
import cookieAlmondButter from "../assets/img/menuItemImages/cookies/Almond Butter Cookie.png";
import cookieChocoBrownie from "../assets/img/menuItemImages/cookies/Choco Brownie Cookie.png";
import cookieFruitNNut from "../assets/img/menuItemImages/cookies/Fruit N Nut Cookie.png";
import cookieBrownBite from "../assets/img/menuItemImages/cookies/Brown Bite Cookie.png";
import GallerySlider from "./GallerySlider";
import bannerOneZeppoli from "../assets/img/resizedImages/bannerOneZeppoli.webp";
import bannerTwoZeppoli from "../assets/img/resizedImages/bannerTwoZeppoli.webp";
import bannerThreeZeppoli from "../assets/img/resizedImages/bannerThreeZeppoli.webp";
import bannerFourZeppoli from "../assets/img/resizedImages/bannerFourZeppoli.webp";
import bannerFiveZeppoli from "../assets/img/resizedImages/bannerFiveZeppoli.webp";
import AmreliLocationImage from "../assets/img/AmreliLocationImage.jpg";
import MangrolLocationImage from "../assets/img/MangrolLocationImage.jpg";
import ManavadarLocationImage from "../assets/img/ManavadarLocationImage.jpg";
import festivalBannerTwo from "../assets/img/festivalBannerTwo.jpg";
import festivalBannerOne from "../assets/img/festivalBannerOne.jpg";

function Home() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Home";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // Reference to the Slider component
  const sliderRef = React.useRef();

  // use for open and close modal
  const categoryList = [
    { title: "RAJKOT", image: rajkotLocationImage },
    { title: "GONDAL", image: GondalLocationImage },
    { title: "JETPUR", image: JetpurLocationImage },
    { title: "JUNAGADH", image: JunagadhLocationImage },
    { title: "KESHOD", image: KeshodLocationImage },
    { title: "PORBANDAR", image: porbandarLocationImage },
    { title: "UPLETA", image: UpletaLocationImage },
    { title: "DHORAJI", image: DhorajiLocationImage },
    { title: "VERAVAL", image: VeravalLocationImage },
    { title: "MENDARDA", image: MendardaLocationImage },
    { title: "AMRELI", image: AmreliLocationImage },
    { title: "MANAVADAR", image: ManavadarLocationImage },
    { title: "MANGROL", image: MangrolLocationImage },
  ];

  const [isLoaded, setIsLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalImage, setShowModalImage] = useState("");
  const handleShowModal = (image) => {
    setShowModal(true);
    setShowModalImage(image);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Number of slides to show at a time
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const testimonialSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
  };
  // Function to handle click on the previous button
  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };
  // Function to handle click on the next button
  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  /*----------- 08. Custom Animaiton For Slider ----------*/
  useEffect(() => {
    document.querySelectorAll("[data-ani-duration]").forEach((element) => {
      const durationTime = element.getAttribute("data-ani-duration");
      element.style.animationDuration = durationTime;
    });

    document.querySelectorAll("[data-ani-delay]").forEach((element) => {
      const delayTime = element.getAttribute("data-ani-delay");
      element.style.animationDelay = delayTime;
    });

    document.querySelectorAll("[data-ani]").forEach((element) => {
      const animationName = element.getAttribute("data-ani");
      element.classList.add(animationName);
      document
        .querySelector(".slick-current [data-ani]")
        .classList.add("th-animated");
    });

    const handleAfterChange = (event, slick, currentSlide, nextSlide) => {
      slick.$slides.forEach((slide) => {
        slide.querySelectorAll("[data-ani]").forEach((element) => {
          element.classList.remove("th-animated");
        });
      });

      slick.$slides[currentSlide]
        .querySelectorAll("[data-ani]")
        .forEach((element) => {
          element.classList.add("th-animated");
        });
    };

    const carouselElement = document.querySelector(".th-carousel");

    if (carouselElement) {
      carouselElement.addEventListener("afterChange", handleAfterChange);
    }

    return () => {
      if (carouselElement) {
        carouselElement.removeEventListener("afterChange", handleAfterChange);
      }
    };
  }, []);

  useEffect(() => {
    // Handle filter button click
    $(".tab-menu1 button").on("click", function () {
      const filterValue = $(this).attr("data-filter");

      // Remove the 'active' class from all buttons and add it to the clicked button
      $(".tab-menu1 button").removeClass("active");
      $(this).addClass("active");

      // Hide all items and show only the ones with the selected class
      $(".filter-active .filter-item").hide();
      $(`.filter-active .filter-item${filterValue}`).show();
    });
  }, []);

  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  };

  // for menu items Our Popular Delicious Foods
  const menuItems = [
    {
      categoryClassName: "cat1",
      image: cakeImageTwoZeppoli,
      title: "Choco Nuts",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat10",
      image: donutDelightsZeppoli,
      title: "Donut Delights",
      categoryName: "Dessert",
    },
    {
      categoryClassName: "cat7",
      image: farsanOneZeppoli,
      title: "Mix Chavanu",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat3",
      image: khariThree,
      title: "Butter Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat9",
      image: breadFiveZeppoli,
      title: "Fresh Pav (400 Gm Pav)",
      categoryName: "Pav",
    },
    {
      categoryClassName: "cat5",
      image: cookieAlmondButter,
      title: "Almond Butter Cookie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageFiveZeppoli,
      title: "Red Velvet",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat10",
      image: dessertImageTwoZeppoli,
      title: "Blue Berry Cheesecake",
      categoryName: "Dessert",
    },
    {
      categoryClassName: "cat9",
      image: breadFourZeppoli,
      title: "Garlic Loaf",
      categoryName: "Pav",
    },
    {
      categoryClassName: "cat3",
      image: khariFour,
      title: "Wheat Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat7",
      image: farsanFourZeppoli,
      title: "Soya Sticks",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat5",
      image: cookieChocoBrownie,
      title: "Choco Brownie",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageSixZeppoli,
      title: "Rasmalay",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat10",
      image: dessertImageOneZeppoli,
      title: "Biscoff Cheesecake",
      categoryName: "Dessert",
    },
    {
      categoryClassName: "cat9",
      image: breadThreeZeppoli,
      title: "Burger Bun",
      categoryName: "Bun",
    },
    {
      categoryClassName: "cat3",
      image: khariNine,
      title: "Masala Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat7",
      image: farsanTwoZeppoli,
      title: "Butter Bhakharvadi",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat5",
      image: cookieFruitNNut,
      title: "Fruit and Nuts",
      categoryName: "Cookie",
    },
    {
      categoryClassName: "cat1",
      image: cakeImageThreeZeppoli,
      title: "Royal Cassata",
      categoryName: "Cake",
    },
    {
      categoryClassName: "cat2",
      image: PastryImageThree,
      title: "Fruit Pastry",
      categoryName: "Pastry",
    },
    {
      categoryClassName: "cat9",
      image: breadOneZeppoli,
      title: "White Sliced Bread",
      categoryName: "Bread",
    },
    {
      categoryClassName: "cat3",
      image: khariTwo,
      title: "Jeera Khari",
      categoryName: "Khari",
    },
    {
      categoryClassName: "cat7",
      image: farsanFiveZeppoli,
      title: "Masala Wafers",
      categoryName: "Farsan",
    },
    {
      categoryClassName: "cat5",
      image: cookieBrownBite,
      title: "Brown Bite Cookie",
      categoryName: "Cookie",
    },
  ];

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    // Set a timeout to change the visibility after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  // video play pause functionality - when one video is playing pause another video
  const videoArray = [
    {
      videoLink: zeppoliReelVideoOne,
    },
    {
      videoLink: zeppoliReelVideoTwo,
    },
    {
      videoLink: zeppoliReelVideoThree,
    },
    {
      videoLink: zeppoliReelVideoFour,
    },
    {
      videoLink: zeppoliReelVideoFive,
    },
    {
      videoLink: zeppoliReelVideoSix,
    },
    {
      videoLink: zeppoliReelVideoSeven,
    },
    {
      videoLink: zeppoliReelVideoEight,
    },
  ];
  const videoRefs = useRef([]);
  const handlePlay = (index) => {
    // Pause all videos except the one that was just played
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });
  };

  useEffect(() => {
    window.addEventListener("load", function () {
      setIsLoaded(true);
    });
  }, [isLoaded]);

  return (
    <>
      <Navbar />

      {/* {isLoaded && ( */}
      <div className="mt-30">
        <div data-aos="fade-in">
          <Slider
            dots={true}
            infinite={true}
            speed={1000}
            slidesToShow={1}
            slidesToScroll={1}
            autoplay={false}
            autoplaySpeed={3500}
            arrows={false}
          >
            <div className="mt-lg-3">
              <img
                src={festivalBannerOne}
                alt="Zeppoli Cookie Banner"
                srcSet={`${festivalBannerOne} 300w,
                ${festivalBannerOne} 500w,
                ${festivalBannerOne} 1000w,
                ${festivalBannerOne} 2000w`}
                width={2000}
                height={600}
                className="mt-lg-5 w-100"
              />
            </div>
            <div className="mt-lg-5">
              <img
                src={festivalBannerTwo}
                alt="Zeppoli Cookie Banner"
                srcSet={`${festivalBannerTwo} 300w,
                ${festivalBannerTwo} 500w,
                ${festivalBannerTwo} 1000w,
                ${festivalBannerTwo} 2000w`}
                width={2000}
                height={600}
                className="mt-lg-5 w-100"
              />
            </div>
            {/* <div>
                <video
                  controls
                  loading="lazy"
                  preload="metadata"
                  autoPlay
                  muted
                  playsInline
                >
                  <source src={bannerVideoOne} type="video/mp4" />
                  <track
                  src="captions_en.vtt"
                  kind="captions"
                  srclang="en"
                  label="english_captions"
                />
                </video>
            </div> */}
            <div>
              <img
                src={bannerOneZeppoli}
                alt="Zeppoli Cookie Banner"
                srcSet={`${bannerOneZeppoli} 300w,
                ${bannerOneZeppoli} 500w,
                ${bannerOneZeppoli} 1000w,
                ${bannerOneZeppoli} 2000w`}
                width={2000}
                height={600}
                className="w-100"
              />
            </div>
            <div>
              <img
                src={bannerTwoZeppoli}
                alt="Zeppoli Cookie Banner"
                srcSet={`${bannerTwoZeppoli} 300w,
                ${bannerTwoZeppoli} 500w,
                ${bannerTwoZeppoli} 1000w,
                ${bannerTwoZeppoli} 2000w`}
                width={2000}
                height={600}
                className="w-100"
              />
              {/* <LazyLoadImage
                alt="Zeppoli Snake Banner"
                effect="opacity"
                src={bannerTwoZeppoli}
                placeholderSrc={bannerTwoZeppoli}
                threshold={200}
              /> */}
            </div>
            <div>
              <img
                src={bannerThreeZeppoli}
                alt="Zeppoli Cookie Banner"
                srcSet={`${bannerThreeZeppoli} 300w,
                ${bannerThreeZeppoli} 500w,
                ${bannerThreeZeppoli} 1000w,
                ${bannerThreeZeppoli} 2000w`}
                width={2000}
                height={600}
                className="w-100"
              />
            </div>
            <div>
              <img
                src={bannerFourZeppoli}
                alt="Zeppoli Cookie Banner"
                srcSet={`${bannerFourZeppoli} 300w,
                ${bannerFourZeppoli} 500w,
                ${bannerFourZeppoli} 1000w,
                ${bannerFourZeppoli} 2000w`}
                width={2000}
                height={600}
                className="w-100"
              />
            </div>
            <div>
              <img
                src={bannerFiveZeppoli}
                alt="Zeppoli Cookie Banner"
                srcSet={`${bannerFiveZeppoli} 300w,
                ${bannerFiveZeppoli} 500w,
                ${bannerFiveZeppoli} 1000w,
                ${bannerFiveZeppoli} 2000w`}
                width={2000}
                height={600}
                className="w-100"
              />
            </div>
          </Slider>
        </div>
      </div>
      {/* )} */}

      {/* {isLoaded && ( */}
      <section className="space" data-aos="fade-up">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-sm-auto mb-n2 mb-sm-0">
              <div className="title-area text-center text-sm-start">
                <h2 className="sec-title">Our Location</h2>
              </div>
            </div>
            <div className="col-sm d-none d-sm-block">
              <div className="title-border"></div>
            </div>
            <div className="col-sm-auto">
              <div className="sec-btn text-center">
                <div className="icon-box">
                  <button
                    onClick={handlePrevClick}
                    className="slick-arrow default"
                    name="leftArrow"
                    aria-label="leftArrow"
                  >
                    <i className="far fa-arrow-left"></i>
                  </button>
                  <button
                    onClick={handleNextClick}
                    className="slick-arrow default"
                    name="rightArrow"
                    aria-label="rightArrow"
                  >
                    <i className="far fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Slider
            {...sliderSettings}
            ref={sliderRef}
            className="row slider-shadow th-carousel"
            id="catSlide1"
          >
            {categoryList.map((customer, index) => (
              <div className="col-sm-6 col-xl-4 px-2" key={index}>
                <div className="category-card">
                  <div className="category-card_img px-4">
                    <img
                      src={ourLocationIcon}
                      srcSet={`${ourLocationIcon} 300w,
                        ${ourLocationIcon} 500w,
                        ${ourLocationIcon} 1000w,
                        ${ourLocationIcon} 2000w`}
                      alt="Zeppoli location icon"
                      width={"50px"}
                      height={"50px"}
                    />
                  </div>
                  <div className="category-card_content">
                    <h3 className="category-card_title">
                      <Link to="/">{customer.title}</Link>
                    </h3>
                    <span
                      className="icon-btn"
                      onClick={() => handleShowModal(customer.image)}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="far fa-plus"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      {/* )} */}
      {showModal && (
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Body className="p-1 border-radius-8px">
            <button
              className="btn btn-danger border-radius-8px"
              name="closeButton"
              aria-label="closeButton"
              onClick={handleCloseModal}
              style={{
                position: "absolute",
              }}
            >
              <i className="fa fa-close"></i>
            </button>
            <div className="text-center">
              <img
                src={showModalImage}
                alt="Zeppoli Modal Image"
                style={{
                  width: "100%",
                  height: "100%",
                }}
                className="border-radius-8px"
              />
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* {isLoaded && ( */}
      <div
        className="container mb-5"
        data-aos="fade-up"
        style={{
          minHeight: "300px",
        }}
      >
        <div className="row mx-0">
          <div className="col-xl-5 pe-xxl-5 my-1">
            <div className="img-box2">
              <div>
                <img
                  src={aboutUsPageNewImage}
                  className="border-radius-12px"
                  alt="Zeppoli About Us Content Image"
                  width="500"
                  height="500"
                />
              </div>

              {/* <div className="">
                <img
                  src={aboutUsPageNewImage}
                  className="border-radius-12px"
                  srcSet={`${aboutUsPageNewImage} 300w,
                      ${aboutUsPageNewImage} 500w`}
                  alt="Zeppoli About Us Content Image"
                  width={500}
                  height={500}
                />
              </div> */}
            </div>
          </div>
          <div className="col-xl-7 my-1">
            <div className="title-area mb-30">
              <span className="sub-title">About Us</span>
              <div className="text-dark fw-bold fs-1 line-height-normal">
                The Art of Sweetness: Nurturing Traditions at Zeppoli Bakers
              </div>
            </div>
            <p className="mt-n2 mb-20">
              'Zeppoli Bakers' is a leading bakery factory based in the scenic
              town of Dhoraji in the Saurashtra region. We have been providing
              our customers with the highest quality baked goods for many years.
              Our bakery is known for its delicious cakes, pastries, bread,
              buns, toasts, and other bakery products. We take great pride in
              using only the freshest and finest ingredients in all of our
              products to ensure that our customers enjoy the best possible
              taste.
            </p>
            <div className="btn-wrap style1">
              <Link to="/about" className="th-btn">
                DISCOVER MORE
              </Link>
              <div className="about-counter1">
                <h3 className="counter-title">
                  <span className="counter-number">8</span>
                </h3>
                <div className="media-body">
                  <p className="counter-info">YEARS OF</p>
                  <div className="counter-text text-dark">Experience</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}

      {/* {isLoaded && ( */}
      <section className="space z-index-common mx-0">
        <div className="bg-img shape_style1" data-bg-src={feature_bg_1}></div>
        <div className="container" data-aos="fade-up">
          <div className="title-area text-center">
            <span className="sub-title">Our Strength</span>
            <h2 className="sec-title">Our Most Loved Products</h2>
            <p className="sec-text ms-auto me-auto">
              Revel in the Exquisite Flavor Profiles of Our Most Loved and
              Exclusively Crafted Artisanal Delights
            </p>
          </div>
          <div className="feature-grid-wrap">
            <div className="feature-grid" data-aos="fade-up">
              <div className="feature-grid_img">
                <img
                  src={cookiesOurProduct}
                  alt="Zeppoli Cookie Icon"
                  width={"80px"}
                  height={"80px"}
                />
              </div>
              <div>
                <h3 className="feature-grid_title box-title">Cookie</h3>
                <p className="feature-grid_text">
                  Indulge in the delightful world of Zeppoli Bakers' cookies,
                  where each bite is a symphony of flavor and texture.
                </p>
              </div>
            </div>
            <div className="feature-grid" data-aos="flip-up">
              <div className="feature-grid_img">
                <img
                  src={cakeOurProduct}
                  alt="Zeppoli Cake Icon"
                  width={"80px"}
                  height={"80px"}
                />
              </div>
              <div>
                <h3 className="feature-grid_title box-title">
                  Customized Cake
                </h3>
                <p className="feature-grid_text">
                  Baked to perfection, each slice promises a symphony of flavors
                  that dance on your palate.
                </p>
              </div>
            </div>
            <div className="feature-grid" data-aos="fade-down">
              <div className="feature-grid_img">
                <img
                  src={breadOurProduct}
                  alt="Zeppoli Bun Icon"
                  width={"80px"}
                  height={"80px"}
                  // className="w-25 h-25"
                />
              </div>
              <div>
                <h3 className="feature-grid_title box-title">Bun</h3>
                <p className="feature-grid_text">
                  Handcrafted with care, our buns are soft, pillowy, and
                  irresistibly fresh.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* )} */}

      {/* {isLoaded && ( */}
      <div
        className="space counter-sec1"
        data-bg-src={greyBanner}
        data-overlay="title"
        data-opacity="9"
      >
        <div className="container z-index-common pt-4">
          <div className="row gy-40 justify-content-between text-align-center">
            <div className="col-sm-6 col-xl-auto">
              <div className="counter-card">
                <div className="media-body">
                  <div className="my-3">
                    <img
                      src={counter_1_1}
                      alt="Zeppoli cusotmer service icon"
                      // className="h-50 w-50"
                      width={"50px"}
                      height={"50px"}
                    />
                  </div>
                  <div className="counter-card_number d-inline-flex fw-bold">
                    <span className="fs-1">
                      {isVisible && <NumberCounter endValue={1} duration={1} />}
                    </span>
                    <span className="fs-1">
                      M<span className="plus mt-4">+</span>
                    </span>
                  </div>
                  <p className="counter-card_text">CUSTOMER SERVICE</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xl-auto">
              <div className="counter-card">
                <div className="media-body">
                  <div className="my-3">
                    <img
                      src={counter_1_2}
                      alt="Zeppoli years of experience icon"
                      width={"40px"}
                      height={"40px"}
                    />
                  </div>
                  <div className="counter-card_number d-inline-flex fw-bold">
                    <span className="fs-1">
                      {isVisible && <NumberCounter endValue={8} duration={1} />}
                    </span>
                    <span className="fs-1">
                      <span className="plus mt-4">+</span>
                    </span>
                  </div>
                  <p className="counter-card_text">YEARS OF EXPERIENCE</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xl-auto">
              <div className="counter-card">
                <div className="media-body">
                  <div className="my-3">
                    <img
                      src={counter_1_3}
                      alt="Zeppoli saurashtra public icon"
                      width={"50px"}
                      height={"50px"}
                    />
                  </div>
                  <div className="counter-card_number d-inline-flex fw-bold">
                    <span className="fs-1">
                      {isVisible && (
                        <NumberCounter endValue={38} duration={1} />
                      )}
                    </span>
                    <span className="fs-1">
                      M<span className="plus mt-4">+</span>
                    </span>
                  </div>
                  <p className="counter-card_text">OF SAURASHTRA PUBLIC</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xl-auto">
              <div className="counter-card">
                <div className="media-body">
                  <div className="my-3">
                    <img
                      src={counter_1_4}
                      alt="Zeppoli cake serves icon"
                      width={"40px"}
                      height={"40px"}
                    />
                  </div>
                  <div className="counter-card_number d-inline-flex fw-bold">
                    <span className="fs-1">
                      {isVisible && (
                        <NumberCounter endValue={100} duration={1} />
                      )}
                    </span>
                    <span className="fs-1">
                      K<span className="plus mt-4">+</span>
                    </span>
                  </div>
                  <p className="counter-card_text">CAKES SERVES PER YEAR</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}

      <div
        className="shape-mockup chili jump-reverse"
        data-top="0%"
        data-right="0"
        style={{ right: "0px" }}
        data-aos="fade-left"
      >
        <img
          src={bread_img1}
          alt="Zeppoli shape icon"
          width={"80px"}
          height={"80px"}
        />
      </div>

      <section className="space">
        <div className="container">
          <div className="title-area text-center" data-aos="fade-up">
            <span className="sub-title">Popular Menu</span>
            <h2 className="sec-title">Our Popular Delicious Foods</h2>
            <p className="sec-text ms-auto me-auto">
              Discover the joy of savoring moments with Zeppoli Bakers – where
              quality meets creativity, and every bite is a celebration of
              exceptional taste.
            </p>
          </div>

          {/* {isLoaded && ( */}
          <div className="row gy-40 filter-active">
            {menuItems.map((data, index) => {
              return (
                <div
                  className={`col-xl-3 col-lg-4 col-sm-6 filter-item ${data.categoryClassName}`}
                  key={index}
                >
                  <div className="th-product product_style1" data-aos="fade-up">
                    <div
                      style={{
                        filter:
                          "drop-shadow(0.15rem 0.15rem 0.2rem rgba(0, 0, 0, 0.5))",
                        borderRadius: "10px",
                      }}
                      className="popular-menu-product-img mx-30"
                    >
                      <LazyLoadImage
                        alt="Zeppoli popular menu items image"
                        className="popular-menu-product-img__img"
                        wrapperClassName="popular-menu-product-img__wrap"
                        effect="blur"
                        height="100%"
                        width="100%"
                        src={data.image}
                        placeholderSrc={data.image}
                      />
                    </div>
                    <div className="product-content my-4">
                      <p className="product-title">{data.title}</p>
                      <p className="category">{data.categoryName}</p>
                      <span className="price"></span>
                    </div>
                  </div>
                </div>
              );
            })}
            <div
              className="btn-wrap style1"
              style={{
                display: "block",
                textAlign: "center",
              }}
            >
              <Link to="/popularmenuitems" className="th-btn">
                VIEW ALL
              </Link>
            </div>
          </div>
          {/* )} */}
        </div>
      </section>

      <div
        className="z-index-common"
        data-pos-for="#bookingSec1"
        data-sec-pos="bottom-half"
        data-aos="fade-up"
      >
        <div className="title-area text-center">
          <span className="sub-title">A Taste of </span>
          <h2 className="sec-title">Zeppoli’s Finest Moments</h2>
          <p className="sec-text ms-auto me-auto">
            {" "}
            Every Zeppoli is a story crafted with care. Join us behind the
            scenes to see how our team creates treats that leave lasting
            memories.
          </p>
        </div>

        {/* {isLoaded && ( */}
        <div className="container">
          <div className="row">
            {videoArray.map((data, index) => (
              <div className="col-lg-3 col-12 py-2" key={index}>
                {index === 1 || index === 3 || index === 5 || index === 7 ? (
                  <div data-aos="fade-up">
                    <div className="video-box1">
                      <Fancybox options={opts}>
                        <video
                          key={index}
                          ref={(el) => (videoRefs.current[index] = el)}
                          onPlay={() => handlePlay(index)}
                          controls
                          loading="lazy" // Lazy loading
                          preload="metadata" // Preload only metadata for faster load
                          width="250px" // Responsive width
                          height="400px" // Adjust height according to width to maintain aspect ratio
                          style={{ borderRadius: "12px", maxWidth: "250px" }}
                        >
                          <source src={data.videoLink} type="video/mp4" />
                          <track
                            src="captions_en.vtt"
                            kind="captions"
                            srclang="en"
                            label="english_captions"
                          />
                        </video>

                        {/* <video
                          key={index}
                          ref={(el) => (videoRefs.current[index] = el)}
                          onPlay={() => handlePlay(index)}
                          controls
                          // src={data.videoLink}
                          style={{ height: "400px", borderRadius: "12px" }}
                        >
                          <source
                            src={data.videoLink}
                            type="video/mp4"
                          ></source>
                          <track
                            src="captions_en.vtt"
                            kind="captions"
                            // srclang="en"
                            label="english_captions"
                          ></track>
                        </video> */}
                      </Fancybox>
                    </div>
                  </div>
                ) : (
                  <div data-aos="zoom-in">
                    <div className="video-box1">
                      <Fancybox options={opts}>
                        <video
                          key={index}
                          ref={(el) => (videoRefs.current[index] = el)}
                          onPlay={() => handlePlay(index)}
                          controls
                          loading="lazy" // Lazy loading
                          preload="metadata" // Preload only metadata for faster load
                          width="250px" // Responsive width
                          height="400px" // Adjust height according to width to maintain aspect ratio
                          style={{ borderRadius: "12px", maxWidth: "250px" }}
                        >
                          <source src={data.videoLink} type="video/mp4" />
                          <track
                            src="captions_en.vtt"
                            kind="captions"
                            srclang="en"
                            label="english_captions"
                          />
                        </video>
                      </Fancybox>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* )} */}
      </div>

      <section className="mt-20">
        <div className="shape-mockup bg-shape2" data-top="120px" data-left="0">
          <img
            src={bg_shape_3}
            srcSet={`${bg_shape_3} 500w,
                ${bg_shape_3} 1000w,
                ${bg_shape_3} 2000w`}
            alt="Zeppoli Background Image"
            width={800}
            height={400}
          />
        </div>
        <div
          className="shape-mockup bg-shape2 d-block d-xl-none"
          data-bottom="0"
          data-left="right"
        >
          <img
            src={bg_shape_2}
            alt="Zeppoli shape icon"
            width={"100%"}
            height={"100%"}
          />
        </div>
        <div className="container">
          <div className="row space-extra">
            <div className="col-xl-5" data-aos="fade-up">
              <div className="title-area text-center text-xl-start">
                <span className="sub-title">Feedbacks</span>
                <h2 className="sec-title">Our Customer Feedbacks</h2>
                <p className="sec-text ms-auto me-auto ms-xl-0">
                  Each testimonial is a reflection of the delightful experiences
                  our patrons have had with our delectable treats
                </p>
              </div>
              <div className="testi-slide-wrap mx-3">
                <Slider
                  {...testimonialSettings}
                  className="row slider-shadow th-carousel"
                  style={{
                    boxShadow: "1px 1px 10px #e1e2e3",
                    borderRadius: "20px",
                    cursor: "pointer",
                  }}
                >
                  <div className="col-xl-4 col-lg-6">
                    <div className="mx-2">
                      <div className="testi-box_icon">
                        <img
                          src={quote_left}
                          alt="Zeppoli testimonial icon"
                          width="50"
                          height="50"
                        />
                      </div>
                      <p className="testi-box_text">
                        “Nice place to ordering birthday cakes. And always fresh
                        items available in there storage..”
                      </p>
                      <div className="testi-box_review">
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                      </div>
                      <div className="testi-box_profile">
                        <div className="testi-box_avater">
                          <img
                            src={profile_img1}
                            alt="Zeppoli customer review profile icon"
                            loading="eager"
                            width={"95%"}
                            height={"95%"}
                          />
                        </div>
                        <div className="media-body">
                          <h3 className="testi-box_name">Ahmedhusen Saiyad</h3>
                          <span className="testi-box_desig">India</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-6">
                    <div className="mx-2">
                      <div className="testi-box_icon">
                        <img
                          src={quote_left}
                          alt="Zeppoli testimonial icon"
                          width="50"
                          height="50"
                        />
                      </div>
                      <p className="testi-box_text">
                        “A one stop CAKE SHOP IN DHORAJI DIST RAJKOT.. KNOWN
                        PLACE TO BUY FRESH BAKERY ITEMS... TO PLACE ORDER FOR
                        CAKES..”
                      </p>
                      <div className="testi-box_review">
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                      </div>
                      <div className="testi-box_profile">
                        <div className="testi-box_avater">
                          <img
                            src={profile_img2}
                            alt="Zeppoli testimonial icon"
                            width="50"
                            height="50"
                          />
                        </div>
                        <div className="media-body">
                          <h3 className="testi-box_name">Jasmin Pandya</h3>
                          <span className="testi-box_desig">India</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-6">
                    <div className="mx-2">
                      <div className="testi-box_icon">
                        <img
                          src={quote_left}
                          alt="Zeppoli testimonial icon"
                          width="50"
                          height="50"
                        />
                      </div>
                      <p className="testi-box_text">
                        “Live pastries. Best breads and biscuits. Best bakery
                        product I have ever tested.”
                      </p>
                      <div className="testi-box_review">
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                        <i className="fa-sharp fa-solid fa-star"></i>
                      </div>
                      <div className="testi-box_profile">
                        <div className="testi-box_avater">
                          <img
                            src={profile_img3}
                            alt="Zeppoli testimonial icon"
                            width="50"
                            height="50"
                          />
                        </div>
                        <div className="media-body">
                          <h3 className="testi-box_name">Munaf Noorani</h3>
                          <span className="testi-box_desig">India</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
            <div className="col-xl-7 d-none d-xl-block" data-aos="fade-down">
              <div className="text-center text-xl-start">
                <LazyLoadImage
                  alt="Feedback Zeppoli"
                  effect="blur"
                  wrapperProps={{
                    style: { transitionDelay: "1s", marginTop: "80px" },
                  }}
                  src={croissant_img1}
                  placeholderSrc={croissant_img1}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <GallerySlider />

      <Footer />
    </>
  );
}

export default Home;
